export const formatActivityDuration = (
  durationMs?: number | null,
  startedAtUtc?: string,
  nowMs = Date.now(),
): string => {
  let elapsedMs = durationMs;

  if (elapsedMs === undefined || elapsedMs === null) {
    if (!startedAtUtc) {
      return "";
    }

    const startedAtMs = Date.parse(startedAtUtc);
    if (!Number.isFinite(startedAtMs)) {
      return "";
    }

    elapsedMs = Math.max(0, nowMs - startedAtMs);
  }

  const totalSeconds = Math.floor(Math.max(0, elapsedMs) / 1000);
  if (totalSeconds < 60) {
    return `${totalSeconds}s`;
  }

  const totalMinutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (totalMinutes < 60) {
    return `${totalMinutes}m ${seconds.toString().padStart(2, "0")}s`;
  }

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}h ${minutes.toString().padStart(2, "0")}m ${seconds.toString().padStart(2, "0")}s`;
};
